export const COLUMN_HEADERS = {
  "Site ID Duration (start to last site ID)":
    "Site ID Duration (start to last site ID) (weeks)",
  "Submission to Approval":
    "Submission to First Site Start-up Activities Complete (weeks)",
  "Approval to First Site Initiated":
    "Approval to First Site Activated (weeks)",
  "Site Initiation Duration": "Site Activation Duration (weeks)",
};
